import { PageableResult } from "../../../../models/domains/paginator/pageable-result";
import { AbstractParser } from "../../parser";
import { TherapeuticClass } from "src/app/ui/models/domains/pbm/Benefit/therapeutic-class";

export class SearchTherapeuticClassesByParser extends AbstractParser<PageableResult> {
  parse(payload: any): PageableResult {
    const pageableResult = new PageableResult();
    pageableResult.setStart(payload.Start);
    pageableResult.setEnd(payload.TotalPerPages);
    pageableResult.setTotalItems(payload.Total);
    pageableResult.setItems(this.parseTherapeuticClassProducts(payload.Data));
    return pageableResult;
  }

  private parseTherapeuticClassProducts(payload: Array<any>): Array<TherapeuticClass> {
    const terapeuticClassProductList: Array<TherapeuticClass> = payload.map((item) => {
      const therapeuticClassProduct = new TherapeuticClass();
      therapeuticClassProduct.setTherapeuticClassKey(item.TherapeuticClassKey);
      therapeuticClassProduct.setDescription(item.Description);
      therapeuticClassProduct.setCode(item.Code);
      return therapeuticClassProduct;
    });
    return terapeuticClassProductList;
  }
}
